import Form from 'semantic-ui-react/dist/es/collections/Form';
import './Form.css';
// Ensure Button styles are loaded with Form...
// There has to be a better way to do this...
import '../elements/Button.css';

export default Form;
